/** Money and stat formatting for the ledger. */

/** A net figure with an explicit sign: +$748, −$300, even. */
export function signedMoney(n: number): string {
  if (n === 0) return 'even';
  const sign = n > 0 ? '+' : '−';
  return `${sign}$${Math.abs(n).toLocaleString('en-US')}`;
}

export function money(n: number): string {
  return `$${Math.abs(n).toLocaleString('en-US')}`;
}

export function points(n: number): string {
  return n.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

export function record(wins: number, losses: number, ties: number): string {
  return ties > 0 ? `${wins}-${losses}-${ties}` : `${wins}-${losses}`;
}

/** First name + last initial, for tight columns. */
export function shortName(full: string): string {
  const [first, ...rest] = full.split(' ');
  const last = rest.at(-1);
  return last ? `${first} ${last[0]}.` : first ?? full;
}

export function ordinal(n: number): string {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] ?? s[v] ?? 'th');
}

/** Compact "how long ago": just now · 4m · 3h · 2d, then a date. */
export function relativeTime(iso: string, now = Date.now()): string {
  const diff = now - new Date(iso).getTime();
  if (!Number.isFinite(diff)) return '';
  const s = Math.floor(diff / 1000);
  if (s < 45) return 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d`;
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
